export default __webpack_public_path__ + "static/media/video-bg.1fb72290.webp";